<div class="page-container">
  <div>
    <h1 class="title title-black">Welcome to the WEEE Forum</h1>
    <h1 class="title title-green">
      Key Figures Platform
      <app-help-icon-button [code]="'dashboard'"></app-help-icon-button>
    </h1>
  </div>

  <div *ngIf="isVisible(['WF_ADMIN', 'SIMPLE_USER', 'WS_COUNTRY_COORDINATOR', 'WS_ADMIN', 'COLLECTED', 'INTELLIGENCE_CHARTS'])">
    <div fxLayout="row" fxFlex fxLayout.sm="column" fxLayout.xs="column">

      <div fxLayout="row wrap" fxLayout.xs="column" fxFlex.gt-lg="50" fxFlex.sm="100" fxFlex.xs="100" class="dashboard-group"
           *ngIf="isVisible(['WF_ADMIN', 'SIMPLE_USER', 'WS_COUNTRY_COORDINATOR', 'WS_ADMIN', 'COLLECTED'])">

        <div fxLayout="row" fxFlex="100"><h1>Key Figures</h1></div>

        <div fxFlex="50" *ngFor="let item of keyFiguresItems" class="item-container" [hidden]="!isVisible(item.roles) && checkCollectedData(item)">
          <app-dashboard-item [item]="item"></app-dashboard-item>
        </div>
      </div>

      <div fxLayout="row wrap" fxLayout.xs="column" fxFlex.gt-lg="50" fxFlex.sm="100" fxFlex.xs="100" class="dashboard-group"
           *ngIf="hideCharts ? isVisible(['CHARTS']) : isVisible(['WF_ADMIN', 'INTELLIGENCE_CHARTS'])">

        <div fxLayout="row" fxFlex="100"><h1>Intelligence</h1></div>

        <div fxFlex="50" *ngFor="let item of intelligenceItems" class="item-container" [hidden]="!isVisible(item.roles)">
          <app-dashboard-item [item]="item"></app-dashboard-item>
        </div>
      </div>
    </div>
  </div>
  <div *ngIf="isVisible(['NEW_USER'])">
    Welcome to the Key Figures platform! Since this is your first time accessing the platform, we have sent an email to the WEEE Forum Office to activate your user.
    We will alert you by email when your user has been activated. If you have not received an email in 48 hours, check your spam or contact us by email: lucia.herreras@weee-forum.org
  </div>

</div>
